<template>
	<div class="menu-items">
		<router-link :to="tab.linkto" class="item" v-for="(tab, index) in tabs" :key="index" @click.native="closeSidebar">
			<i class="icon" :class="tab.icon"/>
			{{ tab.title }}
		</router-link>
	</div>
</template>

<script>
	export default {
		name: 'sidebar',

		props: {
			tabs: {
				required: true,
				default: null,
				type: Array
			}
		},

    methods: {
      closeSidebar () {
        let sidebar = $('.ui.sidebar')

        if (window.innerWidth <= 1200 && sidebar.hasClass('visible')) {
          sidebar.sidebar('toggle');
        }
      }
    }

	}
</script>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue